import { Link } from "react-router-dom";
import { ArrowUpRight, TrendingUp, LineChart, Globe2, Briefcase, Layers, Building2, Banknote, Wallet, ScrollText, Repeat, Hourglass, Network } from "lucide-react";
import SectionHeader from "../components/SectionHeader";
import { SERVICES } from "../lib/services";

const ICONS = { TrendingUp, LineChart, Globe2, Briefcase, Layers, Building2, Banknote, Wallet, ScrollText, Repeat, Hourglass, Network };

export default function ServicesPage() {
  return (
    <main data-testid="services-page" className="pt-32">
      <section className="pb-16">
        <div className="container-myc max-w-4xl">
          <p className="eyebrow">Services</p>
          <h1 className="h-display-1 text-[#2A0A0E] mt-6">
            Twelve disciplines.{" "}
            <span className="italic font-normal text-[#7A1F26]">
              One coherent strategy.
            </span>
          </h1>
          <p className="text-slate-600/65 mt-7 text-lg leading-relaxed max-w-2xl">
            From mutual funds to GIFT City structures, every service is
            delivered through the same fiduciary process and senior-led
            governance.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-myc">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-900/[0.04] border border-slate-200/[0.04]">
            {SERVICES.map((s) => {
              const Icon = ICONS[s.icon] || Briefcase;
              return (
                <Link
                  key={s.slug}
                  to={`/services/${s.slug}`}
                  data-testid={`services-page-card-${s.slug}`}
                  className="group bg-[#FAF5EB] hover:bg-[#FAF5EB] p-9 transition-all relative"
                >
                  <div className="flex items-start justify-between">
                    <div className="w-12 h-12 border border-[#7A1F26]/30 inline-flex items-center justify-center group-hover:bg-[#7A1F26] group-hover:border-[#7A1F26] transition-all duration-300">
                      <Icon className="w-5 h-5 text-[#7A1F26] group-hover:text-[#FFFFFF] transition-colors" />
                    </div>
                    <ArrowUpRight className="w-5 h-5 text-slate-600/30 group-hover:text-[#7A1F26] -translate-x-1 group-hover:translate-x-0 transition-all" />
                  </div>
                  <h3 className="font-display text-xl text-[#2A0A0E] mt-7">
                    {s.title}
                  </h3>
                  <p className="text-sm text-slate-600/55 leading-relaxed mt-3">
                    {s.short}
                  </p>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}
